import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { SolicitudesService } from '../../services/solicitudes.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmPopComponent} from '../confirm-pop/confirm-pop.component';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import {CurpValidator, RfcValidator, NameValidator, CPValidator, MovilValidator} from '../../validators/validator';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';


import {environment} from '../../../environments/environment';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-disponibilidad',
  templateUrl: './disponibilidad.component.html',
  styleUrls: ['./disponibilidad.component.css'],
  providers: [UserService, UpaegService, SolicitudesService]
})
export class DisponibilidadComponent implements OnInit {
  public programasDisponibles;
  public mensaje;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegService : UpaegService,
    private solicitudesService: SolicitudesService,
    public dialog: MatDialog,
    private fb: FormBuilder
  ) {
    this.programasDisponibles = null;
    this.mensaje = '';


    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });


  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
   this.getProgramasDisponibles();
  }



  getProgramasDisponibles(){

    this.solicitudesService.getApoyosDisponibles().subscribe(response => {
      this.programasDisponibles = null;
      console.log(response);
      if(response.status){
        if(response.programas){
          this.programasDisponibles = response.programas;
          this.mensaje = '';
        }else{
          this.programasDisponibles = response.programas;
          this.mensaje = 'No hay apoyos disponibles para captura en línea en este momento, intente en otro momento';
        }
      }else{
        this.programasDisponibles = null;
        this.mensaje = response.message;
      }


    }, error => {
      console.log(error);
      this.programasDisponibles = null;
      this.mensaje = 'No se pueden cargar los apoyos disponibles en este momento, por favor intente más tarde';
    });/**/
  }

  /*
  getProgramasDisponibles(idUpaeg){
    this.solicitudesService.getProgramasAbiertosUpaeg(idUpaeg).subscribe(response => {
      console.log(response);
      if(response.status){
        if(response.programas){
          this.puedeRegistrar = true;
          this.programasDisponibles = response.programas;
        }else{
          this.puedeRegistrar = false;
          this.programasDisponibles = [];
          this.mensajePuedeRegistrar = 'No hay programas disponibles a los que pueda registrar una pre solicitud';
        }
      }else{
        this.mensajePuedeRegistrar = 'No se pueden cargar los programas disponibles para el registro de solicitudes, error 102';
        this.puedeRegistrar = false;
        this.programasDisponibles = [];
      }

    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });

  }

  */
}
